// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import App from "./App.vue";
import Unauthorized from "./components/unauthorized";
import router from "./router/router";
import store from "./store/store";
import RegisterNucleusComponents from "./helperFunctions/RegisterNucleusComponents";
import i18n from "./i18n";
import mixin from "./plugins/mixin";
import { registerLicense } from "@syncfusion/ej2-base";
// import "../node_modules/@syncfusion/ej2-icons/styles/material.scss";


registerLicense(
    "ORg4AjUWIQA/Gnt2VVhkQlFac1tJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxQdkFhWn1fdXxVRGNYV0U="
);

// Registers all exported Nucleus components
RegisterNucleusComponents();

window.Bus = new Vue();
window.axios = axios;

window.token = localStorage.getItem("token");
window.user = localStorage.getItem("user");

// -- OAuth - Authentication call defaults --
axios.defaults.headers.common.Authorization = `Bearer ${window.token}`;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
// -- OAuth - Authentication calls defaults --

// -- Token Refreshing
let isRefreshingToken = false;

//Logging out? Clear Localstorage first
const logout = getParameterByName("logout");
const requestedRoute = window.location.href.split("?")[0];

const returnUrl = getParameterByName("ReturnURL");
const psClientGuid = getParameterByName("pscg");
const scope = getParameterByName("scp");
const clientId = getParameterByName("cid");


if (logout) {
    store.dispatch("logout");
}

//Check for password reset
if (requestedRoute.includes("/setpassword/")) {
    loadVue();
    stop;
}


if (!requestedRoute.includes("admin")) {
    store
        .dispatch("getClientPacket", [psClientGuid]) //refreshes token first
        .then((clientPacket) => {
            if (
                clientPacket &&
        clientPacket.find((o) => o.name === "psClientName").value != undefined
            ) {
                if (clientPacket.find((o) => o.name === "singleSignOn")) {
                    store.commit(
                        "setSsoOption",
                        clientPacket.find((o) => o.name === "singleSignOn").value
                    );
                }
                //Check to see if user is already logged in
                //ignore access token, it's most likley expired, use refresh token.
                if (
                    localStorage.refresh_token &&
          clientPacket.find((o) => o.name === "singleSignOn").value ==
            "PS-Authenticate"
                ) {
                    store
                        .dispatch("isLoggedIn", [localStorage.refresh_token]) //refreshes token first
                        .then(() => {
                            //is user logging into something?
                            if (requestedRoute.includes("login")) {
                                const payload = {
                                    grant_type: "password",
                                    client_id: clientId,
                                    scope: scope + " offline_access",
                                    username: "*",
                                    password: "*",
                                    access_token: localStorage.access_token,
                                    ps_client: psClientGuid,
                                };

                                store
                                    .dispatch("internalSsoLogin", payload)
                                    .then((response) => {
                                        window.location.replace(
                                            returnUrl +
                        "?token=" +
                        response.data.access_token +
                        "&rt=" +
                        response.data.refresh_token
                                        );
                                    })
                                    .catch((error) => {
                                        console.log(error); //refresh token failed, tokens have been deleted, refresh page.
                                        location.reload();
                                    });
                            }
                        })
                        .catch((error) => {
                            console.log(error); //not logged in, keep going
                        });
                } else {
                    loadVue();
                }
            } else {
                loadUnauthorized();
            }
        })
        .catch((error) => {
            loadUnauthorized();
            console.log(error);
        });
}
else {
    loadVue();
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function loadVue() {
    Vue.config.productionTip = false;
    i18n.locale = "en_US";
    /* eslint-disable no-new */
    new Vue({
        vuetify,
        render: (h) => h(App),
        router,
        store,
        i18n,
    }).$mount("#app");
}

function loadUnauthorized() {
    // Vue.config.productionTip = false;
    // i18n.locale = "en_US";
    // /* eslint-disable no-new */
    // new Vue({
    //     vuetify,
    //     render: (h) => h(Unauthorized),
    //     i18n,
    // }).$mount("#app");
    console.log("hi");
}
